/** SA-1329: one toast when a bulk triage run ends. Renders nothing. */
import { useEffect, useRef } from 'react'
import { useToast } from '@/components/ui/Toast'
import { useInboxStore } from '@/stores/inboxStore'
import { runEndText } from './triageText'

export function TriageRunToast() {
  const { addToast } = useToast()
  const run = useInboxStore((s) => s.triageRun)
  const toasted = useRef<string | null>(null)
  useEffect(() => {
    if (!run || run.status !== 'done' || toasted.current === run.id) return
    toasted.current = run.id
    const trouble = run.items.some((i) => i.state === 'conflict' || i.state === 'refused')
    addToast({ type: trouble ? 'warning' : 'success', title: runEndText(run) })
  }, [run, addToast])
  return null
}
